import { Auth } from '../components/Auth';

export function LoginPage() {
  return <Auth />;
}
